// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"17f14ff6","337":"0b1aba72","453":"034ed021","553":"27082af3","963":"133b4e66"}[chunkId] + ".chunk.js";
};